import { usePostStore } from "../store/post-store"
import { useUserStore } from "../store/user-store"
import { fetchPost, fetchUserProfile } from "../community-api"
import { normalizePost } from "../normalize"
import { dedupFetch, invalidateCache } from "./request-dedup"

const POST_SWR = { staleTime: 5 * 60_000 } // 5 minutes

export async function loadPostDetail(postId: string, options?: { force?: boolean }): Promise<void> {
  const { data } = await dedupFetch(
    `post:${postId}`,
    async () => {
      let post = await fetchPost(postId)
      if (!post) return null

      // 补查作者关注状态（在后端添加 isFollowedAuthor 之前的兼容处理）
      try {
        const profile = await fetchUserProfile(post.author.id)
        if (profile?.isFollowed != null) {
          post = { ...post, author: { ...post.author, isFollowed: profile.isFollowed } }
        }
      } catch {
        /* 静默失败 */
      }

      return post
    },
    {
      ...POST_SWR,
      force: options?.force,
      onStaleRevalidate: (fresh) => {
        if (fresh) {
          const { post: normalized, author } = normalizePost(fresh)
          usePostStore.getState().upsertPost(normalized)
          useUserStore.getState().upsertUser(author)
        }
      },
    },
  )

  if (data) {
    const { post: normalized, author } = normalizePost(data)
    usePostStore.getState().upsertPost(normalized)
    useUserStore.getState().upsertUser(author)
  }
}
